// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"3f118b47","341":"09dee6f4","485":"09dee6f4","895":"09dee6f4"}[chunkId] + ".chunk.css";
};